import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { Modal } from "../../../theme/Component/Modal";
import { Singleton } from '../../../../core/services/Singleton';
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { _AddCommercialCampaign, _CommercialCampaign, _CustomerAddress, _UBLPaymentMeans, _UBLPaymentMeansCode } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { PaymentTypeConst } from "../../../erp/cellEditor/PaymentType/PaymentTypeConst";
import { UBLPaymentMeansEditor } from "../UBLPaymentMeans/UBLPaymentMeansEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";


export const UBLPaymentMeansCode = () => {

    const ublcode = useDataBean(_UBLPaymentMeansCode);
    const paginador = usePaginator();
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [regexStr, setregexStr] = useState<any>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [paginador.page])

    const getLista = () => {

        ublcode.instance.getUBLPaymentMeansCodeCatalog(regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    // setLista(resp.List)
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.UBLMeans = (user.DataBeanProperties.PaymentMeansID ?? "") + "-" + (user.DataBeanProperties.PaymentMeansDescription ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }
    const create = () => {
        ublcode.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        ublcode.instance.deleteUBLPaymentMeansCode(ublcode.bean.IDUBLPaymentMeansCode).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {

        ublcode.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDUBLPaymentMeansCode', visible: true },
        { title: 'Código', property: 'PaymentMeansCode', visible: true },
        { title: 'Forma de pago', property: 'UBLMeans', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Habiltado', property: 'IsEnabled', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Medios de Pago">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={ublcode.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-12">
                                <UBLPaymentMeansEditor
                                    render={ublcode.bean.PaymentMeansID}
                                    idSelector={ublcode.bean.IDUBLPaymentMeans}
                                    onChange={(e) =>
                                        ublcode.setBean({
                                            ...ublcode.bean,
                                            IDUBLPaymentMeans: e.IDUBLPaymentMeans,
                                            PaymentMeansID: e.Name
                                        })
                                    }
                                    returnType="Object"
                                />
                            </div>
                            <div className="col-md-12">
                                <PaymentTypeConst idSelector={ublcode.bean.Type} onChange={(e) => { ublcode.setBean({ ...ublcode.bean, "Type": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Código</label>
                                <input type="text" name="PaymentMeansCode" className="form-control" value={ublcode.bean.PaymentMeansCode} onChange={(e) => { ublcode.setBean({ ...ublcode.bean, "PaymentMeansCode": e.target.value }) }} />
                            </div>
                            <div className="col-md-6 mt-4">
                                <BasicSwitch label="Habilitado" estado={ublcode.bean.IsEnabled} eventChange={(e: any) => { ublcode.setBean({ ...ublcode.bean, "IsEnabled": e }) }}></BasicSwitch>
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={ublcode.bean.Description} onChange={ublcode.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {ublcode.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}